/*
* Side Menu
*/


dvApp.workspace = {};

dvApp.sideMenu = [

];
